/* Boot Screen */
.bootScreen {
  position: absolute;
  inset: 0;
  background: #0a0a0a;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 100;
  opacity: 1;
  transition: opacity 0.6s ease;
}

.bootScreen.booting {
  background: #0c0c0c;
}

.bootContent {
  width: 100%;
  max-width: 500px;
  padding: var(--space-6);
}

.bootTerminal {
  font-family: var(--font-mono);
  font-size: var(--caption-size);
  color: #33ff33;
}

.bootHeader {
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-2);
  border-bottom: 1px solid #33ff3344;
  color: #33ff33;
  font-weight: var(--font-semibold);
}

.bootMessages {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.bootLine {
  display: flex;
  gap: var(--space-2);
  animation: bootLineIn 0.1s ease;
}

@keyframes bootLineIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bootPrefix {
  color: #22aa22;
}

.bootCursor {
  color: #33ff33;
  animation: none;
}
